import { Toaster } from '@leadsales/design-system/react';
import { ReactPortal } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { tProvidersProps } from '../LayoutProvider/Layout.types';
import { ToastContext } from './Toast.context';
import useToast from './Toast.hook';
import { tToastAlert } from './Toast.types';
import Alert from './components/Alert.component';
import Toast from './components/Toast.component';

export default function ToastProvider(props: tProvidersProps) {
  const { children } = props;
  const toast = useToast();
  const { t } = useTranslation('common/toast');

  const toastPortal: ReactPortal = createPortal(
    <Toast>
      {toast.alerts.map((alert: tToastAlert) => (
        <Alert key={alert.id} alert={alert} onDelete={toast.deleteAlert} />
      ))}
    </Toast>,
    document.body,
  );

  return (
    <ToastContext.Provider value={toast}>
      {children}

      {toast.alerts.length ? toastPortal : null}

      {/* The DS toast, for new code: `toast.success(...)` from
          @leadsales/design-system/react. It sits below the navbar like the
          one above, and the region stays mounted so a screen reader hears the
          first toast too. Moving the addAlert calls over is a separate step. */}
      <Toaster
        className="!top-[var(--LayoutPrivate-nav-height,0px)]"
        label={t('regionLabel')}
        closeLabel={t('close')}
      />
    </ToastContext.Provider>
  );
}
